import { ModalWrapper } from "src/utils/fw"
import { modalColor } from "../utils"

const linkProps = {
    target: "_blank",
    style: {
        color: "black",
        textDecoration: "none",
        background: "white",
        padding: "10px 8px",
        borderRadius: "6px",
        fontWeight: "bold"
    }
}

const textStyle = {
    color: "white",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    width: "80%"
}

export default ({socialMedia = [], image, text, companyUrl, companyName, room, socialMediaCss = {}}) => {
    return <ModalWrapper wrapperStyle={{
        background: modalColor,
        maxWidth: "700px",
    }}>
        <div style={{display: "flex", flexDirection: "column", width: "100%", alignItems: "center"}}>
            <div style={{
                height: "50%",
                width: "100%",
                display: "flex",
                justifyContent: "center"
            }}>
                <a
                    target="_blank"
                    href={companyUrl}
                    id={`${companyName} website`}
                    data-event-action="Link Click"
                    data-event-label={`${companyName} website`}
                    data-event-category={`exhibition-hall-${room}`}
                >
                    <img style={{ height: "100%", background: "white", borderRadius: "10px" }} src={image} />
                </a>
            </div>
            
            <p style={textStyle}>
                {text}
            </p>
            
            <div style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "40%",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "2em",
                ...socialMediaCss
            }}>
                {socialMedia.map(it => {
                    return <a 
                        href={it.url}
                        target="_blank"
                        id={`${companyName} ${it.name}`}
                        data-event-action="Link Click"
                        data-event-label={`${companyName} ${it.name}`}
                        data-event-category={`exhibition-hall-${room}`}
                        {...linkProps}
                    >{it.name}</a>
                })}
            </div>
        </div>
    </ModalWrapper>
}